export class Envelope {
  minX: number;

  maxX: number;

  minY: number;

  maxY: number;

  hasZ?: boolean;

  minZ?: number;

  maxZ?: number;

  hasM?: boolean;

  minM?: number;

  maxM?: number;
}
